import gsap from 'gsap'

import { utils, store } from '@/core'
import { lenis } from '../app'

const { qs, qsa } = utils
const { dom, device } = store

export default function () {

    const burgerMenu = qs('.burger')
    const jsCloseItems = qsa('.js-close-menu')
    const subMenu = qsa('.menu_mobile .sub-menu')
    const subMenues = qsa('.menu_mobile .submenu')
    burgerMenu && 
    burgerMenu.addEventListener('click', ()=>{
        burgerMenu.classList.toggle('open')
        if(burgerMenu.classList.contains('open')){
            openMenu()
        }else{
            closeMenu()

        }
    })
    jsCloseItems.forEach(e => e.addEventListener('click', ()=> closeMenu() ))

    subMenu.forEach( sb => sb.addEventListener('click', ()=>{
        if(sb.querySelector('.submenu').style.display !== 'block'){
            subMenues.forEach( s => s.style.display = "none")
            sb.querySelector('.submenu').style.display = "block"
        }else{
            subMenues.forEach( s => s.style.display = "none")
        }
    }))

    function closeMenu(){
       // console.log('cierra')
        qs('.menu_mobile').classList.add('hide')
        qs('.burger').classList.remove('open')

        qs('body').style.overflowY='initial'
        //lenis.start()
    }
    function openMenu(){
       // console.log('abre')
        qs('.menu_mobile').classList.remove('hide')
        qs('body').style.overflowY='hidden'
        //lenis.stop()

    }
}